module.exports = __webpack_public_path__ + "static/media/agreement.118842a8.svg";